import teamsPosession from '@/store/modules/teams/posession';
import teamsOffensive from '@/store/modules/teams/offensive';
import teamsDefensive from '@/store/modules/teams/defensive';
import teamsGeneral from '@/store/modules/teams/general';

export default {
  teamsPosession,
  teamsOffensive,
  teamsDefensive,
  teamsGeneral,
};
